<template>
  <div class="select" :class="{active : isSelectCollapsed}">
        <div class="select__active-item select__container" 
        @click="toggleDropdown"
        >
            <p class="placeholder">{{ curPlaceholder }}</p>
            <i class="fas fa-angle-down" ></i>
            <div class="select__dropdown select__container">
                <p v-for="option in options" :key="option.id" @click="filterCountries(option.value)">{{option.value}}</p>
            </div>
        </div>
        
  </div>
</template>

<script>
export default {
    data() {
        return {
            isSelectCollapsed: false,
            curPlaceholder: 'Asia'
        }
    },
    props: {
        placeholder: String,
        options: Array,
    },
    methods: {
        toggleDropdown() {
            this.isSelectCollapsed = !this.isSelectCollapsed
        },
        filterCountries(selectedRegion) {
            this.curPlaceholder = selectedRegion
            this.$emit('filterCountries', selectedRegion)
        }
    }
}
</script>

<style lang="scss">
.select {
    margin-bottom: 2rem;
    &__container {
        width: 12.5rem;
        
        background-color: hsl(0, 0%, 100%);
        box-shadow: 0 2px 6px rgba($color: #000000, $alpha: .07);
        border-radius: 5px;
        
    }

    &__active-item {
        margin-top: .7em;
        padding: .75em 1.75em;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        
        @media (min-width: 46.88em) {
            margin: .75rem 0 0 1rem;
            padding: .880rem 2rem;
        }
        @media (min-width: 48em) {
            cursor: pointer;
        }

        & .fa-angle-down {
            transition: transform 200ms ease-out; 
        }
    }
    &__dropdown {
        margin-top: .3em;
        max-height: 0px;
        overflow: hidden;
        position: absolute;
        top: 100%;
        left: 0;

        transition: max-height 200ms ease-out;
        & > p {
            padding: .3em 1.75em;
            @media (min-width: 48em) {
                cursor: pointer;
            }
            &:first-child { padding-top: 1.05em }
            &:last-child { padding-bottom: 1.05em }
            
        }
    }

    &.active {
        .fa-angle-down { transform: rotate(180deg) }
        .select__dropdown { max-height: 12em; }
    }
}
</style>